import React, { FC, ReactNode } from 'react';
import styled from 'styled-components';

import GridItem from '@ui/atoms/GridItem';

import fullWidth from '@ui/styled/FullWidth';

export interface ICenteredGridItemProps {
	children?: ReactNode;
	className?: string;
}

const CenteredGridItem: FC<ICenteredGridItemProps> = ({ children, className }) => {
	return (
		<GridItem columnStart={[1, 2, 3, 4]} columnEnd={[5, 8, 11, 10]} className={className}>
			{children}
		</GridItem>
	);
};

export default styled(fullWidth(CenteredGridItem))``;
